document.addEventListener("click", function(event) {
    var addButton = event.target.closest(".js-add-context-item");

    if (addButton) {
        var itemKind = addButton.dataset.itemKind;
        var isGroupHeader = addButton.dataset.isGroupHeader;
        var section = addButton.closest(".strategic-risk-context-items");
        var body = section.querySelector(".js-context-items-body[data-item-kind='" + itemKind + "']");
        var template = section.querySelector(".js-context-item-template[data-item-kind='" + itemKind + "'][data-is-group-header='" + isGroupHeader + "']");

        if (!body || !template) return;

        var html = template.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
        body.insertAdjacentHTML("beforeend", html);
        return;
    }

    var removeButton = event.target.closest(".js-remove-context-item");

    if (removeButton) {
        var row = removeButton.closest("tr");
        var deletedInput = row.querySelector(".js-context-item-deleted");

        if (deletedInput) {
            deletedInput.value = "true";
        }

        row.style.display = "none";
    }
});